import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import Header from "../components/Header";
import Footer from "../components/Footer";

const BRAND = "#FEF233";
const API_URL = process.env.REACT_APP_API_URL;

const businessDetails = [
  {
    icon: "bi-geo-alt-fill",
    title: "Our Office",
    lines: ["Bazarna FZ-LLC", "Business Bay, Dubai", "United Arab Emirates"],
  },
  {
    icon: "bi-telephone-fill",
    title: "Call Us",
    lines: ["+971 50 541 9868", "Sun – Thu, 9:00 AM – 6:00 PM"],
  },
  {
    icon: "bi-envelope-fill",
    title: "Email Us",
    lines: ["info@bazarnauae.com"],
  },
  {
    icon: "bi-globe",
    title: "Website",
    lines: ["https://bazarnauae.com"],
  },
];

const initialForm = { name: "", email: "", phone: "", subject: "", message: "" };

const ContactUs = () => {
  const { pathname } = useLocation();
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await axios.post(`${API_URL}/seller/submitContact`, {
        name: form.name,
        email: form.email,
        phone: form.phone,
        message: form.subject ? `[${form.subject}] ${form.message}` : form.message,
      });

      Swal.fire({
        icon: "success",
        title: "Message Sent!",
        text: `Thank you, ${form.name}. Our team will get back to you shortly.`,
        confirmButtonColor: BRAND,
        confirmButtonText: "Done",
        iconColor: BRAND,
      });

      setForm(initialForm);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Message Not Sent",
        text: "Something went wrong on our end. Please try again or reach us directly using the details below.",
        confirmButtonColor: BRAND,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="from-top">
        <Header />

        <div className="heading-policy flex-column text-center">
          <h1>Contact Us</h1>
        </div>
      </div>

      <div className="container my-5">
        <div className="text-center mb-5">
          <p className="text-muted">
            Have a question, feedback, or a partnership idea? We'd love to hear
            from you. Reach out using the details below or send us a message.
          </p>
        </div>

        {/* Business details */}
        <div className="row g-4 mb-5">
          {businessDetails.map((item) => (
            <div className="col-lg-3 col-md-6" key={item.title} data-aos="fade-up">
              <div
                className="h-100 p-4 text-center rounded-4 shadow-sm"
                style={{ backgroundColor: "#f7f7f7", border: "none" }}
              >
                <span
                  className="d-inline-flex align-items-center justify-content-center mb-3"
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    backgroundColor: BRAND,
                    fontSize: 22,
                    color: "#111",
                  }}
                >
                  <i className={`bi ${item.icon}`}></i>
                </span>
                <h5 className="fw-bold mb-2">{item.title}</h5>
                {item.lines.map((line) => (
                  <p className="mb-1 text-muted small" key={line}>
                    {line}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Contact form */}
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div
              className="p-4 p-md-5 rounded-4 shadow-sm"
              style={{ backgroundColor: "#ffffff", border: "1px solid #eee" }}
              data-aos="fade-up"
            >
              <h4 className="fw-bold mb-4 text-center">Send Us a Message</h4>
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label text-muted">Full Name</label>
                    <input
                      type="text"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      className="form-control"
                      style={{ backgroundColor: "#f5f5f5", border: "none" }}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label text-muted">Email Address</label>
                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      className="form-control"
                      style={{ backgroundColor: "#f5f5f5", border: "none" }}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label text-muted">Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      className="form-control"
                      style={{ backgroundColor: "#f5f5f5", border: "none" }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label text-muted">Subject</label>
                    <input
                      type="text"
                      name="subject"
                      value={form.subject}
                      onChange={handleChange}
                      className="form-control"
                      style={{ backgroundColor: "#f5f5f5", border: "none" }}
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label text-muted">Message</label>
                    <textarea
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                      className="form-control"
                      rows="5"
                      style={{ backgroundColor: "#f5f5f5", border: "none" }}
                      required
                    ></textarea>
                  </div>

                  <div className="col-12 text-center mt-2">
                    <button
                      type="submit"
                      className="btn fw-bold hover-rise-sm"
                      disabled={submitting}
                      style={{
                        backgroundColor: BRAND,
                        color: "black",
                        borderRadius: "10px",
                        padding: "10px 40px",
                      }}
                    >
                      {submitting ? "Sending…" : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ContactUs;
